import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import '../styles/VehicleSelector.css';

const VehicleSelector = ({ vehicles, selectedVehicle, onSelect }) => {
  return (
    <div className="mb-4 vehicle-selector-shell">
      <div className="vehicle-selector-heading">
        <div>
          <span className="vehicle-selector-kicker">Vehicle Match</span>
          <h6 className="mb-1 fw-bold">Select Vehicle Type</h6>
          <p className="mb-0 text-muted">Choose the best option based on parcel weight and route.</p>
        </div>
      </div>
      <Row className="g-2">
        {Object.entries(vehicles).map(([key, vehicle]) => (
          <Col xs={6} sm={6} md={3} key={key} className="d-flex">
            <Card
              className={`vehicle-card cursor-pointer h-100 w-100 ${selectedVehicle === key ? 'selected' : ''}`}
              onClick={() => onSelect(key)}
            >
              <Card.Body className="text-center p-3 d-flex flex-column align-items-center">
                <div className="vehicle-icon mb-2">{vehicle.icon}</div>
                <small className="text-muted d-block vehicle-name">{vehicle.name}</small>
                <small className="text-secondary d-block vehicle-capacity">{vehicle.capacity}</small>
                <div className="vehicle-metrics mt-3 d-flex flex-wrap gap-2 justify-content-center">
                  <Badge bg="info" className="vehicle-metric-badge">
                    Rs {vehicle.costPerKm}/km
                  </Badge>
                  <Badge bg="success" className="vehicle-metric-badge">
                    {vehicle.capacity}
                  </Badge>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default VehicleSelector;
